import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class YearListTask extends GenericRequest {

    _request; // YearListRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.MONTHLY_PRESENCE_YEARS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/year-list/YearListTask.js